import React, {useState, setState, useRef, useEffect} from 'react';
import Input from "@hig/input";

export default function Search(props) {

  const [value, setValue] = useState('');

  const search = (e) => {
    e.preventDefault();
    //if (value) {
      window.location.href = `/search/?s=${encodeURIComponent(value)}&from=${encodeURIComponent('//aps.autodesk.com/')}`;
    //}
  };

  return (
    <form className={`aps__search`} onSubmit={search}>
      <div className={`aps__search-button`} onClick={search}></div>
      <input
        data-test-id="nav-header-search-input"
        data-external-target="nav-header-search-input"
        placeholder=''
        className={`aps__search-input`}
        defaultValue={value}
        onInput={(e) => setValue(e.target.value)}
        type="search"
      />
    </form>
  );
}
